require.register("ffss/ui/modal/IFrame", function(exports, require, module){
  $0
  
});

